/**
 * Next's Link also cancels clicks for client routing, so `defaultPrevented`
 * cannot tell "navigating" from "opened in place". Handlers that open a view
 * over the current page mark the native event so the shell skips its
 * route-loading overlay.
 */
const openedInPlace = new WeakSet<Event>();

export function markOpenedInPlace(event: { nativeEvent: Event }) {
  openedInPlace.add(event.nativeEvent);
}

export function wasOpenedInPlace(event: Event) {
  return openedInPlace.has(event);
}
